"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Boilerplate = window.cccisd.boilerplate;
var _default = exports["default"] = function _default(navs, routes) {
  var path = '/';
  var re = new RegExp("".concat(Boilerplate.settings.uriBase, "(.+)"));
  var matches = window.location.pathname.match(re);
  if (matches) {
    path += window.location.pathname.match(re)[1];
    var route = (0, _filter2["default"])(routes, function (r) {
      return r.url === path;
    });
    if (!(0, _isEmpty2["default"])(route)) {
      var handle = route[0].handle;
      var nav = {};
      navs.forEach(function (n) {
        if ((0, _find2["default"])(n.nav, function (navItem) {
          return navItem.handle === handle;
        })) {
          nav = n;
        }
      });
      return !(0, _isEmpty2["default"])(nav) ? nav : navs[0];
    }
  }
  return navs.filter(function (nav) {
    return nav.handle !== 'header';
  })[0];
};